import { createReducer } from 'reduxsauce'
import { Types } from '../actions/nfeActions'

const INITIAL_STATE = { loading: false, notas: null, empresas: null }

const begin = (state = INITIAL_STATE, action) => {
    return { ...state, loading: true }
}
const success = (state = INITIAL_STATE, action) => {
    return { ...state, loading: false, notas: action.payload.notas, empresas: action.payload.empresas }
}
const failure = (state = INITIAL_STATE, action) => {
    return { ...state, loading: false, notas: null, empresas: null }
}

const HANDLERS = {
    [Types.FETCH_NFE_BEGIN]: begin,
    [Types.FETCH_NFE_SUCCESS]: success,
    [Types.FETCH_NFE_FAILURE]: failure
}

export default createReducer(INITIAL_STATE, HANDLERS)